webpackJsonp([87],{

/***/ "/19I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3RoH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D/Uc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1fec7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("D/Uc");
function injectStyle (ssrContext) {
  __webpack_require__("/19I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1fec7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_tailwind_css__ = __webpack_require__("3RoH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_tailwind_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_css_tailwind_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_nprogress_nprogress_css__ = __webpack_require__("UVIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// CSS load order: Tailwind preflight FIRST, then Bootstrap (overrides preflight
// on legacy BootstrapVue screens), then the rest.
// See: discovery/lumen_web/css-load-order













// Theme boot: apply saved preference before first paint.
// Default is light mode (no dark class).  Toggle is handled by
// ThemeToggle.vue in Slice 2; here we only restore a persisted state.
;(function () {
  var saved = localStorage.getItem('lumen.ui.theme');
  if (saved === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
})()

// Defensive migration: copy stray 'menus' key to 'menu' if present.
// Guards against copy-paste contamination from Stana (which had a menus/menu
// mismatch).  Lumen itself already uses 'menu' — this is belt-and-braces.
;(function () {
  var stray = localStorage.getItem('menus');
  var correct = localStorage.getItem('menu');
  if (stray && !correct) {
    localStorage.setItem('menu', stray);
    localStorage.removeItem('menus');
    console.info('[lumen] Migrated localStorage.menus → localStorage.menu');
  }
})();

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = true;

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].mixin({
  data: function data() {
    return {
      get urlAPI() {
        //return 'http://localhost:37400/v1';
        window.urlAPI = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip ? "https://api.nubetech.software/lumen/v1" : "http://127.0.0.1:37500/lumen_desa/v1";
        return __WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip ? "https://api.nubetech.software/lumen/v1" : "http://127.0.0.1:37500/lumen_desa/v1";
      }
    };
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */] }
});

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress__ = __webpack_require__("Y81h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nprogress__);




var Home = function Home() {
    return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, "lO7g"));
};
var Login = function Login() {
    return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, "xJsL"));
};
var Welcome = function Welcome() {
    return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, "FJN/"));
};

var AplicacionEdit = function AplicacionEdit() {
    return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, "L1ry"));
};
var AplicacionList = function AplicacionList() {
    return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, "f2OA"));
};

var AplicacionVersionEdit = function AplicacionVersionEdit() {
    return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, "IYpg"));
};
var AplicacionVersionList = function AplicacionVersionList() {
    return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, "y+Sz"));
};

var ContadorList = function ContadorList() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "gf0p"));
};
var ContadorEdit = function ContadorEdit() {
    return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "L85b"));
};

var ContadorClienteEdit = function ContadorClienteEdit() {
    return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "XP/K"));
};
var ContadorClienteList = function ContadorClienteList() {
    return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, "TrJh"));
};

var ContadorClienteDocumentoEdit = function ContadorClienteDocumentoEdit() {
    return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "7Hzp"));
};
var ContadorClienteDocumentoList = function ContadorClienteDocumentoList() {
    return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "neOg"));
};

var ContadorDocumentoList = function ContadorDocumentoList() {
    return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "6evd"));
};
var ContadorDocumentoEdit = function ContadorDocumentoEdit() {
    return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, "JN0V"));
};

var ContribuyenteEdit = function ContribuyenteEdit() {
    return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, "QBlh"));
};
var ContribuyenteList = function ContribuyenteList() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "kOUs"));
};

var DashboardEdit = function DashboardEdit() {
    return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, "fd++"));
};
var DashboardList = function DashboardList() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "BAjF"));
};

var DeviceEdit = function DeviceEdit() {
    return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, "I8m2"));
};
var DeviceList = function DeviceList() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "VZdV"));
};

var DocumentoEdit = function DocumentoEdit() {
    return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "1NHQ"));
};
var DocumentoList = function DocumentoList() {
    return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "hdfb"));
};

var EntidadEdit = function EntidadEdit() {
    return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, "u7pf"));
};
var EntidadList = function EntidadList() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "d3/a"));
};

var FacturaEdit = function FacturaEdit() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "LgFl"));
};
var FacturaList = function FacturaList() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "ojmg"));
};

var FeriadoList = function FeriadoList() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "BIkH"));
};
var FeriadoEdit = function FeriadoEdit() {
    return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, "Eve5"));
};

var IvaTipoEdit = function IvaTipoEdit() {
    return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "JsXx"));
};
var IvaTipoList = function IvaTipoList() {
    return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "RPHY"));
};

var MenuEdit = function MenuEdit() {
    return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, "XxnX"));
};
var MenuList = function MenuList() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "ot2n"));
};

var PaisList = function PaisList() {
    return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "l1b3"));
};
var PaisEdit = function PaisEdit() {
    return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, "jhTM"));
};

var PerfilList = function PerfilList() {
    return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "8/KD"));
};
var PerfilEdit = function PerfilEdit() {
    return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, "+PX2"));
};

var RubroEdit = function RubroEdit() {
    return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, "qYC3"));
};
var RubroList = function RubroList() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "poel"));
};

var TimbradoEdit = function TimbradoEdit() {
    return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "MgEy"));
};
var TimbradoList = function TimbradoList() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "vr5n"));
};

var UsuarioEdit = function UsuarioEdit() {
    return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "xu0I"));
};
var UsuarioList = function UsuarioList() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "doRx"));
};

var UsuarioRolEdit = function UsuarioRolEdit() {
    return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "1SmR"));
};
var UsuarioRolList = function UsuarioRolList() {
    return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "IMcO"));
};

var UsuarioRolMenuEdit = function UsuarioRolMenuEdit() {
    return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, "0KnU"));
};
var UsuarioRolMenuList = function UsuarioRolMenuList() {
    return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "a6Yb"));
};

var AreaEdit = function AreaEdit() {
    return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, "9orI"));
};
var AreaList = function AreaList() {
    return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, "eYqS"));
};

var DepartamentoEdit = function DepartamentoEdit() {
    return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, "OEpm"));
};
var DepartamentoList = function DepartamentoList() {
    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, "8ha6"));
};

var CiudadEdit = function CiudadEdit() {
    return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, "SxoU"));
};
var CiudadList = function CiudadList() {
    return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, "2Zw8"));
};

var BarrioEdit = function BarrioEdit() {
    return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, "He5n"));
};
var BarrioList = function BarrioList() {
    return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "NrDi"));
};

var CategoriaEdit = function CategoriaEdit() {
    return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, "VvGh"));
};
var CategoriaList = function CategoriaList() {
    return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "AlTG"));
};

var ClaseEdit = function ClaseEdit() {
    return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, "HoUl"));
};
var ClaseList = function ClaseList() {
    return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, "49/Y"));
};

var ZonaEdit = function ZonaEdit() {
    return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, "rupP"));
};
var ZonaList = function ZonaList() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "umsy"));
};

var ClienteEdit = function ClienteEdit() {
    return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "Gt6G"));
};
var ClienteList = function ClienteList() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "hTuW"));
};

var ClienteInmuebleEdit = function ClienteInmuebleEdit() {
    return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "sSAw"));
};
var ClienteInmuebleList = function ClienteInmuebleList() {
    return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "vD7/"));
};

var DeudaEdit = function DeudaEdit() {
    return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "FLAm"));
};
var DeudaList = function DeudaList() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "PPXz"));
};

var GastoConceptoEdit = function GastoConceptoEdit() {
    return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "ZTwh"));
};
var GastoConceptoList = function GastoConceptoList() {
    return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "aNaK"));
};

var GastoEdit = function GastoEdit() {
    return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "HWxu"));
};
var GastoList = function GastoList() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "SR2K"));
};

var EmpresaEdit = function EmpresaEdit() {
    return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "+Ibv"));
};
var EmpresaList = function EmpresaList() {
    return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "S2If"));
};

var AlumnoEdit = function AlumnoEdit() {
    return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "Uygp"));
};
var AlumnoList = function AlumnoList() {
    return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "uOLx"));
};

var CursoEdit = function CursoEdit() {
    return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "Ckke"));
};
var CursoList = function CursoList() {
    return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "KOw8"));
};

var CuotaEdit = function CuotaEdit() {
    return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, "Y7RT"));
};
var CuotaList = function CuotaList() {
    return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, "1ate"));
};
var CuotaGenerate = function CuotaGenerate() {
    return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "b7Jb"));
};

var ReportePagoList = function ReportePagoList() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "63Jh"));
};

var ReportePago = function ReportePago() {
    return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "nlR2"));
};
var ReporteDeuda = function ReporteDeuda() {
    return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "H/ZD"));
};
var ReporteFactura = function ReporteFactura() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "cdY0"));
};

var CotizacionList = function CotizacionList() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "4ZKM"));
};
var CotizacionEdit = function CotizacionEdit() {
    return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "QWjr"));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var childrenHome = [{
    path: "",
    name: "Welcome",
    component: Welcome,
    meta: {
        requiresAuth: true
    }
}, {
    path: "aplicacion-list",
    name: "AplicacionList",
    component: AplicacionList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "aplicacion-edit",
    name: "AplicacionEdit",
    component: AplicacionEdit,
    props: true,
    meta: {
        requiresAuth: true
    }
}, {
    path: "aplicacionversion-list",
    name: "AplicacionVersionList",
    component: AplicacionVersionList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "aplicacionversion-edit",
    name: "AplicacionVersionEdit",
    component: AplicacionVersionEdit,
    props: true,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contador-list",
    name: "ContadorList",
    component: ContadorList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contador-edit",
    name: "ContadorEdit",
    props: true,
    component: ContadorEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contadorcliente-edit",
    name: "ContadorClienteEdit",
    props: true,
    component: ContadorClienteEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contadorcliente-list",
    name: "ContadorClienteList",
    component: ContadorClienteList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contadorclientedocumento-edit",
    name: "ContadorClienteDocumentoEdit",
    props: true,
    component: ContadorClienteDocumentoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contadorclientedocumento-list",
    name: "ContadorClienteDocumentoList",
    component: ContadorClienteDocumentoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contadordocumento-edit",
    name: "ContadorDocumentoEdit",
    props: true,
    component: ContadorDocumentoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contadordocumento-list",
    name: "ContadorDocumentoList",
    component: ContadorDocumentoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contribuyente-edit",
    name: "ContribuyenteEdit",
    props: true,
    component: ContribuyenteEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "contribuyente-list",
    name: "ContribuyenteList",
    component: ContribuyenteList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "dashboard-edit",
    name: "DashboardEdit",
    props: true,
    component: DashboardEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "dashboard-list",
    name: "DashboardList",
    component: DashboardList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "device-edit",
    name: "DeviceEdit",
    props: true,
    component: DeviceEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "device-list",
    name: "DeviceList",
    component: DeviceList,
    meta: {
        requiresAuth: true
    }
}, {
    path: 'factura-edit',
    name: 'FacturaEdit',
    props: true,
    component: FacturaEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: 'factura-list',
    name: 'FacturaList',
    component: FacturaList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "documento-edit",
    name: "DocumentoEdit",
    props: true,
    component: DocumentoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "documento-list",
    name: "DocumentoList",
    component: DocumentoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "entidad-edit",
    name: "EntidadEdit",
    props: true,
    component: EntidadEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "entidad-list",
    name: "EntidadList",
    component: EntidadList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "feriado-list",
    name: "FeriadoList",
    component: FeriadoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "feriado-edit",
    name: "FeriadoEdit",
    component: FeriadoEdit,
    props: true,
    meta: {
        requiresAuth: true
    }
}, {
    path: "ivatipo-edit",
    name: "IvaTipoEdit",
    props: true,
    component: IvaTipoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "ivatipo-list",
    name: "IvaTipoList",
    component: IvaTipoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "menu-edit",
    name: "MenuEdit",
    props: true,
    component: MenuEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "menu-list",
    name: "MenuList",
    component: MenuList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "pais-list",
    name: "PaisList",
    component: PaisList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "pais-edit",
    name: "PaisEdit",
    component: PaisEdit,
    props: true,
    meta: {
        requiresAuth: true
    }
}, {
    path: "perfil-list",
    name: "PerfilList",
    component: PerfilList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "perfil-edit",
    name: "PerfilEdit",
    component: PerfilEdit,
    props: true,
    meta: {
        requiresAuth: true
    }
}, {
    path: "rubro-edit",
    name: "RubroEdit",
    props: true,
    component: RubroEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "rubro-list",
    name: "RubroList",
    component: RubroList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "timbrado-edit",
    name: "TimbradoEdit",
    props: true,
    component: TimbradoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "timbrado-list",
    name: "TimbradoList",
    component: TimbradoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "usuario-edit",
    name: "UsuarioEdit",
    props: true,
    component: UsuarioEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "usuario-list",
    name: "UsuarioList",
    component: UsuarioList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "usuariorol-edit",
    name: "UsuarioRolEdit",
    props: true,
    component: UsuarioRolEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "usuariorol-list",
    name: "UsuarioRolList",
    component: UsuarioRolList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "usuariorolmenu-edit",
    name: "UsuarioRolMenuEdit",
    props: true,
    component: UsuarioRolMenuEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "usuariorolmenu-list",
    name: "UsuarioRolMenuList",
    component: UsuarioRolMenuList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "area-edit",
    name: "AreaEdit",
    props: true,
    component: AreaEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "area-list",
    name: "AreaList",
    component: AreaList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "departamento-edit",
    name: "DepartamentoEdit",
    props: true,
    component: DepartamentoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "departamento-list",
    name: "DepartamentoList",
    component: DepartamentoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "ciudad-edit",
    name: "CiudadEdit",
    props: true,
    component: CiudadEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "ciudad-list",
    name: "CiudadList",
    component: CiudadList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "barrio-edit",
    name: "BarrioEdit",
    props: true,
    component: BarrioEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "barrio-list",
    name: "BarrioList",
    component: BarrioList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "categoria-edit",
    name: "CategoriaEdit",
    props: true,
    component: CategoriaEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "categoria-list",
    name: "CategoriaList",
    component: CategoriaList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "clase-edit",
    name: "ClaseEdit",
    props: true,
    component: ClaseEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "clase-list",
    name: "ClaseList",
    component: ClaseList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "zona-edit",
    name: "ZonaEdit",
    props: true,
    component: ZonaEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "zona-list",
    name: "ZonaList",
    component: ZonaList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "cliente-edit",
    name: "ClienteEdit",
    props: true,
    component: ClienteEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "cliente-list",
    name: "ClienteList",
    component: ClienteList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "clienteinmueble-edit",
    name: "ClienteInmuebleEdit",
    props: true,
    component: ClienteInmuebleEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "clienteinmueble-list",
    name: "ClienteInmuebleList",
    component: ClienteInmuebleList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "deuda-edit",
    name: "DeudaEdit",
    props: true,
    component: DeudaEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "deuda-list",
    name: "DeudaList",
    component: DeudaList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "gastoconcepto-edit",
    name: "GastoConceptoEdit",
    props: true,
    component: GastoConceptoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "gastoconcepto-list",
    name: "GastoConceptoList",
    component: GastoConceptoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "gasto-edit",
    name: "GastoEdit",
    props: true,
    component: GastoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "gasto-list",
    name: "GastoList",
    component: GastoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "empresa-edit",
    name: "EmpresaEdit",
    props: true,
    component: EmpresaEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "empresa-list",
    name: "EmpresaList",
    component: EmpresaList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "alumno-edit",
    name: "AlumnoEdit",
    props: true,
    component: AlumnoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "alumno-list",
    name: "AlumnoList",
    component: AlumnoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "curso-edit",
    name: "CursoEdit",
    props: true,
    component: CursoEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "curso-list",
    name: "CursoList",
    component: CursoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "cuota-edit",
    name: "CuotaEdit",
    props: true,
    component: CuotaEdit,
    meta: {
        requiresAuth: true
    }
}, {
    path: "cuota-list",
    name: "CuotaList",
    component: CuotaList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "cuota-generate",
    name: "CuotaGenerate",
    component: CuotaGenerate,
    meta: {
        requiresAuth: true
    }
}, {
    path: "reportepago-list",
    name: "ReportePagoList",
    component: ReportePagoList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "ReportePago",
    name: "ReportePago",
    component: ReportePago,
    meta: {
        requiresAuth: true
    }
}, {
    path: "ReporteDeuda",
    name: "ReporteDeuda",
    component: ReporteDeuda,
    meta: {
        requiresAuth: true
    }
}, {
    path: "ReporteFactura",
    name: "ReporteFactura",
    component: ReporteFactura,
    meta: {
        requiresAuth: true
    }
}, {
    path: "cotizacion-list",
    name: "CotizacionList",
    component: CotizacionList,
    meta: {
        requiresAuth: true
    }
}, {
    path: "cotizacion-edit",
    name: "CotizacionEdit",
    props: true,
    component: CotizacionEdit,
    meta: {
        requiresAuth: true
    }
}];

var routes = [{
    path: "/",
    // name: 'Home',
    component: Home,
    meta: {
        requiresAuth: true
    },
    children: childrenHome
}, {
    path: "/login",
    name: "Login",
    component: Login
},
// todas las rutas que no existan.
{
    path: "*",
    redirect: "/"
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ mode: 'history', routes: routes });

router.beforeEach(function (to, from, next) {
    // check to see if route has auth guard
    if (to.matched.some(function (rec) {
        return rec.meta.requiresAuth;
    })) {
        if (!window.localStorage.getItem("usuario")) {
            next({
                name: "Login"
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

router.beforeResolve(function (to, from, next) {
    // If this isn't an initial page load.
    //console.log(to, from)
    //NProgress.start()
    if (to.name) {
        // Start the route progress bar.
        __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.start();
    }
    next();
});

router.afterEach(function (to, from) {
    __WEBPACK_IMPORTED_MODULE_2_nprogress___default.a.done();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ce02aeb4298aab38aa0c.js